<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler" :popupHandler="popupHandler" :eventHandler="queryEventHanlder"></swb-query-sort-area>
        <template v-if="allAuditFlag && !applyFlag && !voucher.done">
            <div class="hint block">
                <span class="title">温馨提示</span>
                <p>执行单据只能执行审核通过的并且需执行的数据</p>
            </div>
            <div class="simple-row">
                <div class="right">
                    <a class="swb-btn swb-btn-small swb-btn-primary" @click="doneVoucher()">执行</a>
                    <a class="swb-btn swb-btn-small swb-btn-primary" @click="doDoneCheck">执行前检查处理项</a>
                </div>
            </div>
        </template>

        <div class="simple-row" v-if="auditFlag && voucher.applyState == 1 && !allAuditFlag">
            <div class="right">
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="doAuditStateBatch()">批量审核</a>
            </div>
        </div>
        <div class="tab-container small base" v-if="voucher.assetType != 2">
            <div class="tabs-nav">
                <ul class="head">
                    <li :class="{'current': status.value == checkStateValue}" class="head-item" v-for="status in tableState" @click="handleTabClick(status.value)">
                        <span>{{status.text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="table-layout">
            <el-table :data="handleItemList" style="width: 100%" border @selection-change="handleSelectionChange">
                <el-table-column v-if="auditFlag" type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column prop="tmpNo" label="系统编号" width="220" fixed></el-table-column>
                <el-table-column prop="title" label="设备名称" width="200"></el-table-column>
                <el-table-column prop="catName" label="设备分类" width="100"></el-table-column>
                <el-table-column prop="devcCatName" label="资产分类" width="100"></el-table-column>
                <el-table-column prop="brandName" label="设备品牌" width="100"></el-table-column>
                <el-table-column prop="assignedStaffName" label="指派盘点人" width="100"></el-table-column>
                <el-table-column prop="checkerName" label="实际盘点人" width="100"></el-table-column>
                <el-table-column prop="checked" label="是否已盘" width="80">
                    <template slot-scope="rows">
                        <span class="swb-tags swb-tags-success" v-if="rows.row.checked">已盘</span>
                        <span class="swb-tags swb-tags-danger" v-else>未盘</span>
                    </template>
                </el-table-column>
                <el-table-column prop="checkedDelta" label="盘点结果" width="80">
                    <template slot-scope="rows">
                        <span class="swb-tags swb-tags-success" v-if="(rows.row.checked || voucher.state == 2) && rows.row.checkedDelta == 0">正常</span>
                        <span class="swb-tags swb-tags-danger" v-else-if="(rows.row.checked || voucher.state == 2) && rows.row.checkedDelta > 0">盘盈</span>
                        <span class="swb-tags swb-tags-danger" v-else-if="(rows.row.checked || voucher.state == 2) && rows.row.checkedDelta < 0">盘亏</span>
                    </template>
                </el-table-column>
                <el-table-column prop="physicalState" label="实物状态" width="80" v-if="checkStateValue == 0">
                    <template slot-scope="rows">
                        <span class="font-green" v-if="rows.row.checked && rows.row.physicalState == 0">正常</span>
                        <span v-else-if="rows.row.checked && rows.row.physicalState == -1">无实物</span>
                        <span class="font-red" v-else-if="rows.row.checked && rows.row.physicalState == 1">损坏</span>
                    </template>
                </el-table-column>
                <el-table-column prop="checkMemo" label="情况描述" width="100"></el-table-column>
                <el-table-column prop="checkTime" label="盘点时间" width="150"></el-table-column>
                <el-table-column prop="checkedQuantity" label="实盘数量" width="100" align="right" v-if="checkStateValue == 1"></el-table-column>
                <el-table-column prop="checkedDelta" label="盘点差值" width="100" align="right" v-if="checkStateValue == 1"></el-table-column>

                <el-table-column label="出库机构" width="220">
                    <template slot-scope="rows">
                        <span v-if="rows.row.wayValue == -1 || rows.row.wayValue == -2 || rows.row.wayValue == -3 || rows.row.wayValue == -4 || rows.row.wayValue == -5">{{voucher.retailerComName}}</span>
                        <span v-if="rows.row.wayValue == 2">{{rows.row.theOtherComName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="出库仓库" width="120">
                    <template slot-scope="rows">
                        <span v-if="rows.row.wayValue == -1 || rows.row.wayValue == -2 || rows.row.wayValue == -3 || rows.row.wayValue == -4 || rows.row.wayValue == -5">{{voucher.warehouseName}}</span>
                        <span v-if="rows.row.wayValue == 2">{{rows.row.theOtherWarehouseName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="入库机构" width="220">
                    <template slot-scope="rows">
                        <span v-if="rows.row.wayValue == -1 || rows.row.wayValue == -2">{{rows.row.theOtherComName}}</span>
                        <span v-if="rows.row.wayValue == 2 || rows.row.wayValue == 4">{{voucher.retailerComName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="入库仓库" width="120">
                    <template slot-scope="rows">
                        <span v-if="rows.row.wayValue == -1 || rows.row.wayValue == -2">{{rows.row.theOtherWarehouseName}}</span>
                        <span v-if="rows.row.wayValue == 2 || rows.row.wayValue == 4">{{voucher.warehouseName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="单据类型" align="center" width="80">
                    <template slot-scope="rows">
                        <span v-if="rows.row.wayValue == -1 || rows.row.wayValue == -2 || rows.row.wayValue == 2">调拨单</span>
                        <span v-if="rows.row.wayValue == -3 || rows.row.wayValue == -5">清除单</span>
                        <span v-if="rows.row.wayValue == 4">入库单</span>
                        <span v-if="rows.row.wayValue == -4">出库单</span>
                        <span v-if="rows.row.wayValue == -6">报废单</span>
                        <span v-if="rows.row.wayValue == -7">无实物</span>
                    </template>
                </el-table-column>
                <el-table-column prop="doneVoucherNo" label="单据号" align="center" width="200"></el-table-column>
                <el-table-column prop="wayText" label="实物处理" width="100"></el-table-column>
                <el-table-column prop="quantity" label="实物处理数量" width="100" align="right"></el-table-column>
                <el-table-column prop="fiscalWayText" label="财务处理" width="100"></el-table-column>
                <el-table-column prop="fiscalQuantity" label="财务处理数量" width="100" align="right"></el-table-column>
                <el-table-column label="执行完毕" width="80" align="center" v-if="voucher.done">
                    <template slot-scope="rows">
                        <span class="font-green" v-if="rows.row.done">已执行</span>
                        <span v-else>未执行</span>
                    </template>
                </el-table-column>
                <el-table-column label="能否生成单据" width="150" v-if="voucher.done == false">
                    <template slot-scope="rows">
                        <div v-if="rows.row.wayValue == 2">
                            <span v-if="rows.row.theOtherComId != null && rows.row.theOtherWarehouseId != null">可以生成单据</span>
                            <span v-else>无法生成单据</span>
                        </div>
                        <div v-if="rows.row.wayValue == -2">
                            <div v-if="rows.row.theOtherComId != null">
                                <span v-if="rows.row.theOtherComId != voucher.retailerComId">可以生成单据</span>
                                <div v-if="rows.row.theOtherComId == voucher.retailerComId">
                                    <span v-if="rows.row.theOtherWarehouseId != null">可以生成单据</span>
                                    <span v-else>无法生成单据</span>
                                </div>
                            </div>
                            <div v-else>
                                <span>无法生成单据</span>
                            </div>
                        </div>
                        <div v-if="rows.row.wayValue == -3 || rows.row.wayValue == 4 || rows.row.wayValue == -4 || rows.row.wayValue == -6">
                            <span>可以生成单据</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="审核状态" width="100" fixed="right">
                    <template slot-scope="rows">
                        <span>{{auditStateMap[rows.row.auditState]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" v-if="auditFlag" fixed="right">
                    <template slot-scope="rows">
                        <div class="swb-btn swb-btn-link" v-if="rows.row.auditState == 0 && voucher.applyState == 1" @click="doAuditState(rows.row.id)">审核</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="simple-form" v-if="applyFlag">
            <div class="form-group center">
                <div class="form-label">
                    <label class="">申请原因</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-input type="textarea" v-model="applyDesc"></el-input>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import{ openAssetVoucherAuditDlg } from '../scrapVoucher/selectDlg'
    import { showDevcCatSelectDlg } from '../categ/selectDlg'

    import shopDevcApi from '../../api/shopDevc';
    import assetVchrApi from '../../api/assetVchr';
    import userApi from '../../api/user';

    import SwbShopDeviceStockHandleItemSave from './ShopDeviceStockHandleItemSave';
    Vue.regist(SwbShopDeviceStockHandleItemSave);

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "系统编号",
            "code": "tmpNo",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "设备名称",
            "code": "title",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "label": "设备分类",
            "code": "catName",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "label": "设备品牌",
            "code": "brandName",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Select",
            "label": "实物处理",
            "dataList": [],
            "code": "wayValue",
            "valueType": "Integer",
            "basic": true,
        }, {
            "type": "Select",
            "label": "财务处理",
            "dataList": [],
            "code": "fiscalWayValue",
            "valueType": "Integer",
            "basic": true,
        }, {
            "type": "Select",
            "label": "审核状态",
            "dataList": [],
            "code": "auditState",
            "valueType": "Integer",
            "basic": true,
        }, {
            "code": "innerDevcCatId",
            "label": "资产分类",
            "type": "Popup",
            "valueType": "Integer",
            "basic": true,
            "hidden": false,
            "rptUsed": false
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-shop-device-stock-handle-item-audit-list',
        desc: '盘点处理项',
        props: {
            voucherId: {
                type: Number,
                default: null,
            },
            applyFlag: {
                type: Boolean,
                default: false,
            },
            auditFlag: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                voucher: {},
                voucherItem: {},
                handleItemList: [],
                currComId: null,
                currStaffId: null,
                // 能否处理
                wayList: [],
                activeName: null,
                //
                queryConfig: {},
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                queryKey: null,
                queryConfigMap: {},
                applyDesc: null,
                auditStateMap: {},
                allAuditFlag: false,
                // 页签
                checkStateValue: 0,
                tableState: [{
                    "text": "单品式管理",
                    "value": 0,
                }, {
                    "text": "批量式管理",
                    "value": 1,
                }],
                multipleSelection: []
            }
        },
        created: function () {
            //
            this.auditStateMap = getEnumMap('auditState', 'value2text');
            this.getFilterItem();
            this.getAllAuditFlag();
            let self = this;
            self.getCurrUserInfo(function () {
                self.wayTextList();
            });
        },
        methods: {
            // 查询处理项是否全部审核通过
            getAllAuditFlag: function () {
                let self = this;
                let params = {
                    voucherId: self.voucherId
                };
                assetVchrApi.getShopDeviceStockHandleItemsAuditPassFlagByVoucherId(params, function (result) {
                    if(result.type == "info") {
                        self.allAuditFlag = result.data || false;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            //
            handleTabClick(val) {
                this.checkStateValue = val;
                this.getHandleItemList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getHandleItemList();
            },
            getFilterItem: function () {
                let queryConfig = searchConfigData || {};
                let queryConfigMap = queryConfig.queryFields.toMap("code");

                //
                let wayList = getEnumList("assetCheckHandleWay");
                let wayValueList = queryConfigMap["wayValue"];
                let ways = [];
                wayList.forEach(function (item) {
                    let way = {};
                    way.value = item.value;
                    way.label = item.text;
                    ways.push(way);
                });
                wayValueList.dataList = [];
                wayValueList.dataList = Utils.merge([], ways);
                //
                let fiscalWayList = getEnumList("assetCheckFiscalHandleWay");
                let fiscalWays = [];
                fiscalWayList.forEach(function (item) {
                    let fiscalWay = {};
                    fiscalWay.value = item.value;
                    fiscalWay.label = item.text;
                    fiscalWays.push(fiscalWay);
                });
                let fiscalWayValueList = queryConfigMap["fiscalWayValue"];
                fiscalWayValueList.dataList = [];
                fiscalWayValueList.dataList = Utils.merge([], fiscalWays);
                //
                let auditStateList = getEnumList("auditState");
                let auditStates = [];
                auditStateList.forEach(function (item) {
                    let auditState = {};
                    auditState.value = item.value;
                    auditState.label = item.text;
                    auditStates.push(auditState);
                });
                let auditStateInfo = queryConfigMap["auditState"];
                auditStateInfo.dataList = [];
                auditStateInfo.dataList = Utils.merge([], auditStates);

                this.queryConfig = Utils.merge({}, queryConfig);
            },
            popupHandler: function (fieldCode, curValue, curText) {
                let self = this;
                if(fieldCode == 'innerDevcCatId') {
                    showDevcCatSelectDlg({
                        filter: {
                            relSysFlag: true,
                            disabled: false,
                            level: 3
                        },
                    }, function (devcCat, theDlg) {
                        theDlg.close();
                        let devcCatId = devcCat.id;
                        let devcCatName = devcCat.name;
                        //
                        let query_model_ctrl = self.$refs['query_model'];
                        let itemInfo = {
                            innerDevcCatId: {
                                value: devcCatId,
                                text: devcCatName
                            }
                        };
                        //
                        query_model_ctrl.updateFields(itemInfo);
                    });
                }
            },
            queryEventHanlder: function (itemCode, eventName, itemValue, filterItems) {
                if(eventName == 'change') {
                    //
                    if(itemCode == 'innerDevcCatId' && Utils.isNoB(itemValue)) {
                        //
                        let query_model_ctrl = this.$refs['query_model'];
                        let itemInfo = {
                            innerDevcCatId: {
                                value: null,
                                text: null
                            }
                        };
                        //
                        query_model_ctrl.updateFields(itemInfo);
                    }
                }
            },
            // 处理方式页签
            wayTextList: function () {
                let self = this;
                let postData = {
                    voucherId: self.voucherId
                };
                assetVchrApi.getHandleItemWayList(postData, function (result) {
                    if(result.type == "info") {
                        let wayList = result.data || [];
                        if(wayList.length > 0) {
                            self.activeName = wayList[0].wayValue;
                        }
                        self.wayList = Utils.merge([], wayList);
                        //
                        let query_model = self.$refs['query_model'];
                        let ways = [];
                        wayList.forEach(function (item) {
                            let way = {};
                            way.value = item.wayValue;
                            way.label = item.wayText;
                            ways.push(way);
                        });
                        let wayValueInfo = {};
                        wayValueInfo["wayValue"] = {dataList: ways};
                        query_model.updateFields(wayValueInfo);
                        //
                        self.initQuery();
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            initQuery(){
                this.getVoucherInfo();
            },
            getCurrUserInfo(callback){
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        self.currComId = scopeEntity.comId;
                        self.currStaffId = scopeEntity.staffId;
                        callback();
                    }
                });
            },
            getVoucherInfo(){
                let self = this;
                let theLoad = MsgBox.loading();
                let voucherId = self.voucherId;
                assetVchrApi.getShopDeviceStockCheckVoucher({
                    id: voucherId,
                    includeItems: false,
                    includeCount: true
                }, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.voucher = Utils.merge({}, result.data);
                        //
                        if(self.voucher.assetType != 2) {
                            if(self.voucher.totalCount == 0) {
                                self.checkStateValue = 1; // self.activeName = 'durable';
                                //
                                self.tableState = [{
                                    "text": "批量式管理",
                                    "value": 1,
                                }];
                            }
                            if(self.voucher.durableTotalCount == 0) {
                                self.checkStateValue = 0; // self.activeName = 'device';
                                //
                                self.tableState = [{
                                    "text": "单品式管理",
                                    "value": 0,
                                }];
                            }
                        }
                        self.getHandleItemList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getHandleItemList(checkStateValue){
                let self = this;
                let theLoading = MsgBox.loading();
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                filterItems.voucherId = self.voucherId;
                filterItems.durable = true;
                if(Utils.isNoB(checkStateValue)) {
                    checkStateValue = self.checkStateValue;
                }
                if(checkStateValue == 0 && self.voucher.assetType != 2) {
                    filterItems.durable = false;
                }
                assetVchrApi.getShopDeviceStockHandleItemsByVoucherId(filterItems, function (result) {
                    theLoading.close();
                    if(result.type == "info") {
                        let handleItemList = result.data || [];
                        handleItemList.forEach(function (item) {
                            if(item.checkTime != null) {
                                item.checkTime = new Date(item.checkTime).format("yyyy-MM-dd HH:mm:ss")
                            }
                        });
                        //
                        self.handleItemList = Utils.merge([], handleItemList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 审核处理
            doAuditState: function (id) {
                let self = this;
                let title = "结果处理 -- 审核";
                openAssetVoucherAuditDlg(function (result) {
                    let auditState = result.auditState;
                    let postData = {
                        id: id,
                        auditState: auditState,
                        auditDesc: result.desc,
                    };
                    let theLoad = MsgBox.loading();
                    assetVchrApi.doAuditShopDeviceStockHandleItem(postData, function (result) {
                        theLoad.hide();
                        if(result.type == 'info') {
                            MsgBox.success('操作成功！');
                            self.allAuditFlag = result.data;
                            self.getHandleItemList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, title);
            },
            doAuditStateBatch(){
                let self = this;
                if(self.multipleSelection.length == 0) {
                    self.$message.warning("请勾选要审核的行");
                    return;
                }
                for(var i = 0; i < self.multipleSelection.length; i++) {
                    var obj = self.multipleSelection[i];
                    if(obj.auditState != 0) {
                        MsgBox.warning("请选择未审核的进行审核");
                        return;
                    }
                }
                let ids = self.multipleSelection.pluck('id');
                let title = "结果处理 -- 审核";
                openAssetVoucherAuditDlg(function (result) {
                    let auditState = result.auditState;
                    let postData = {
                        ids: ids,
                        auditState: auditState,
                        auditDesc: result.desc,
                    };
                    let theLoad = MsgBox.loading();
                    assetVchrApi.doAuditShopDeviceStockHandleItem(postData, function (result) {
                        theLoad.hide();
                        if(result.type == 'info') {
                            MsgBox.success('操作成功！');
                            self.allAuditFlag = result.data;
                            self.getHandleItemList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, title);
            },
            /**
             * 执行处理
             */
            doneVoucher: function () {
                let self = this;
                Vue.$showDialog({
                    title: '执行处理',
                    showCloseBtn: true,
                    width: 400,
                    height: 300,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>是否自动审核</label>' +
                    '</div>' +
                    '<div class="form-value">' +
                    '<el-radio-group v-model="autoAudit">' +
                    '<el-radio :label="true">是</el-radio>' +
                    '<el-radio :label="false">否</el-radio>' +
                    '</el-radio-group>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        autoAudit: true
                    },
                    methods: {},
                    okClicked: function () {
                        let theLoad = MsgBox.loading();
                        let postData = {};
                        postData.id = self.voucherId;
                        postData.autoAudit = this.autoAudit;
                        assetVchrApi.doShopDeviceStockHandleItemDoneByVoucherId(postData, function (result) {
                            theLoad.hide();
                            if(result.type == 'info') {
                                //
                                MsgBox.success("操作成功!");
                                self.initQuery();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    }
                });
            },
            doDoneCheck() {
                let self = this;
                let voucherId = self.voucherId;
                let postData = {};
                postData.id = voucherId;
                postData.checkFlag = true;
                let theLoad = MsgBox.loading();
                assetVchrApi.doShopDeviceStockHandleItemDoneByVoucherId(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        // 必定异常
                    } else {
                        Toast.show(result.message);
                    }
                })
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                result.data = self.applyDesc;
                return result;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceStockHandleItemAuditStateList.vue